import React, { useState } from "react";
import "./HalfDetails.scss";
import Modal from "../Modal/Modal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Button from "../Button/Button";
import deleteicon from "../../assets/images/Delete.png";

const HalfDetails = ({
  id,
  name,
  handleDelete,
  handleEdit,
  children,
  can_delete,
  can_update,
}) => {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSaveChanges = () => {
    handleEdit();
    setIsEditOpen(false);
  };

  const handleDeleteConfirm = () => {
    handleDelete(id);
    setIsDeleteOpen(false);
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`hdetails ${isExpanded ? "expanded" : ""}`}>
      <Modal isOpen={isDeleteOpen} onClose={() => setIsDeleteOpen(false)}>
        <ConfirmationModal
          onConfirm={handleDeleteConfirm}
          onCancel={() => setIsDeleteOpen(false)}
          ques="Are you sure you want to delete?"
        />
      </Modal>

      <Modal isOpen={isEditOpen} onClose={() => setIsEditOpen(false)}>
        <ConfirmationModal
          onConfirm={handleSaveChanges}
          onCancel={() => setIsEditOpen(false)}
          ques="Are you sure you want to save the changes?"
        />
      </Modal>

      <div className="hdetails-header">
        <div className="hdetails-header-name">
          <span className="item-name">{name}</span>
          <button className="expand-toggle" onClick={toggleExpand}>
            {isExpanded ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 15L12 9L6 15"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        </div>

        <div className="hdetails-header-actions">
          {can_delete && (
            <button
              className="delete-button"
              onClick={() => setIsDeleteOpen(true)}
              title="Delete"
            >
              <img src={deleteicon} alt="Delete" />
            </button>
          )}
        </div>
      </div>

      <div className="hdetails-contents">
        <div className="content-wrapper">{children}</div>
      </div>

      {can_update && (
        <div className="hdetails-footer">
          <Button
            type={`primary`}
            text={`Save Changes`}
            onClick={() => {
              window.scrollTo(0, 0);
              setIsEditOpen(true);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default HalfDetails;

// import "./HalfDetails.scss";

// import deleteicon from "../../assets/images/Delete.png";

// import React, { useState } from "react";
// import Modal from "../Modal/Modal";
// import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
// import Button from "../Button/Button";

// const HalfDetails = ({
//   id,
//   name,
//   handleDelete,
//   handleEdit,
//   children,
//   can_delete,
//   can_update,
// }) => {
//   const [isDeleteOpen, setIsDeleteOpen] = useState(false);
//   const [isEditOpen, setIsEditOpen] = useState(false);

//   const handTest = () => {
//     handleEdit();
//     setIsEditOpen(false);
//   };
//   const handleDeleteHere = () => {
//     handleDelete(id);
//     setIsDeleteOpen(false);
//   };

//   return (
//     <div className="hdetails">
//       <Modal isOpen={isDeleteOpen} onClose={() => setIsDeleteOpen(false)}>
//         <ConfirmationModal
//           onConfirm={handleDeleteHere}
//           onCancel={() => setIsDeleteOpen(false)}
//           ques="Are you sure you want to delete?"
//         />
//       </Modal>
//       <Modal isOpen={isEditOpen} onClose={() => setIsEditOpen(false)}>
//         <ConfirmationModal
//           onConfirm={handTest}
//           onCancel={() => setIsEditOpen(false)}
//           ques="Are you sure you want to save the changes?"
//         />
//       </Modal>
//       <div className="hdetails-header">
//         <div className="hdetails-header-name">{name}</div>
//         {/* <Button text={`Delete`} type={`arrow`} /> */}
//         {can_delete && (
//           <img
//             src={deleteicon}
//             alt="Delete"
//             onClick={() => setIsDeleteOpen(true)}
//           />
//         )}
//       </div>
//       <div className="hdetails-contents">{children}</div>

//       {can_update && (
//         <div className="hdetails-footer">
//           <Button
//             type={`arrow`}
//             text={`Save Changes`}
//             onClick={() => {
//               window.scrollTo(0, 0);
//               setIsEditOpen(true);
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default HalfDetails;
